//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'periódico',
        value: 'periodic',
        align: 'center',
        format: 'boolean',
        input: {
            type: 'checkbox',
            class: 'mx-auto',
            hideDetails: true,
        },
        width: '12%',
    },
    {
        text: 'mes',
        value: 'new_periodic_month',
        align: 'center',
        classes: 'text-capitalize',
        format: 'date-custom',
        options: 'MMMM',
        input: {
            type: 'date-field',
            flat: true,
            pickerProps: {
                type: 'month',
            },
        },
        width: '12%',
    },
    {
        text: 'monto',
        value: 'amount',
        align: 'right',
        format: 'currency',
        input: {
            type: 'currency-field',
            reverse: true,
        },
        width: '12%',
    },
]
